var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15600",
    "data-name": "Group 15600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.463,
    height: 15.543,
    viewBox: "0 0 14.463 15.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5478",
    "data-name": "Rectangle 5478",
    width: 14.463,
    height: 15.543,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15599",
    "data-name": "Group 15599",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29544",
    "data-name": "Path 29544",
    d: "M7.7,15.543H6.757a2,2,0,0,1-1.995-2,.852.852,0,0,0-.115-.4.86.86,0,0,0-1.181-.321,2,2,0,0,1-2.733-.77l-.467-.805A1.993,1.993,0,0,1,.992,8.528a.875.875,0,0,0,.438-.754A.868.868,0,0,0,.994,7.02,2,2,0,0,1,.266,4.293l.506-.834a2,2,0,0,1,2.715-.73.826.826,0,0,0,.42.123.873.873,0,0,0,.862-.859A1.99,1.99,0,0,1,6.757,0H7.7a2,2,0,0,1,2,2.051.788.788,0,0,0,.11.391.86.86,0,0,0,.528.4A.88.88,0,0,0,11,2.748a2,2,0,0,1,2.723.732l.469.814a.316.316,0,0,1,.026.052,2.008,2.008,0,0,1-.752,2.671.827.827,0,0,0-.317.315.863.863,0,0,0,.312,1.188,1.993,1.993,0,0,1,.73,2.728l-.5.831a2,2,0,0,1-2.72.718.939.939,0,0,0-.422-.117.864.864,0,0,0-.852.865,2.013,2.013,0,0,1-2,2M3.9,11.581a2,2,0,0,1,1.987,1.957.873.873,0,0,0,.87.88H7.7a.882.882,0,0,0,.875-.873,1.99,1.99,0,0,1,2-1.99,2.07,2.07,0,0,1,.961.264.873.873,0,0,0,1.192-.311l.5-.833a.845.845,0,0,0,.083-.651.857.857,0,0,0-.4-.529,1.988,1.988,0,0,1-.725-2.728,1.971,1.971,0,0,1,.73-.726.875.875,0,0,0,.311-1.183c-.007-.014-.015-.028-.021-.042l-.446-.774a.871.871,0,0,0-1.185-.321A2,2,0,0,1,8.84,3.014a1.938,1.938,0,0,1-.266-.974.9.9,0,0,0-.247-.647A.866.866,0,0,0,7.7,1.125H6.757A.866.866,0,0,0,5.894,2a2.006,2.006,0,0,1-2,1.981A1.945,1.945,0,0,1,2.92,3.7a.874.874,0,0,0-1.179.331l-.507.835a.873.873,0,0,0,.323,1.18,1.992,1.992,0,0,1,1,1.728,2,2,0,0,1-1,1.728.867.867,0,0,0-.315,1.182l.473.815a.869.869,0,0,0,.526.424.88.88,0,0,0,.668-.077,1.979,1.979,0,0,1,.993-.265m3.334-1.268A2.539,2.539,0,1,1,9.773,7.774a2.544,2.544,0,0,1-2.539,2.539m0-3.954A1.414,1.414,0,1,0,8.648,7.774,1.418,1.418,0,0,0,7.234,6.359",
    fill: "#200e32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.d369c9ddb9f691d29ed77572f3c5b2cd.svg";
export { ForwardRef as ReactComponent };